import { render, staticRenderFns } from "./v-radio-group.vue?vue&type=template&id=7bbfc329&scoped=true&"
import script from "./v-radio-group.vue?vue&type=script&lang=js&"
export * from "./v-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./v-radio-group.vue?vue&type=style&index=0&id=7bbfc329&lang=scss&scoped=true&"
import style1 from "./v-radio-group.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbfc329",
  null
  
)

export default component.exports